import * as types from "./actionTypes";
import { initialState, childState } from "./initialState";
import { cloneDeep } from "../../utils/utils";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_METADATA_FETCH_DATA:
      return setFetchData(state, true);
    case types.API_V1_GET_METADATA_INFO_SUCCESS:
      return setMetadataInfo(state, action.payload);
    case types.API_V1_GET_METADATA_INFO_FAILURE:
      return initialState;
    default:
      return state;
  }
};

const setMetadataInfo = (state, payload) => {
  delete state[0]; // Delete initial child state
  const clonedState = cloneDeep(state);
  clonedState.fetchData = false;

  payload.forEach((account) => {
    const { id, total, status } = account;
    if (!(id in clonedState)) {
      clonedState[id] = cloneDeep(childState); // Initialize as child state
      clonedState[id].id = id;
    }
    clonedState[id].total = total;
    clonedState[id].status = status;
  });
  return clonedState;
};

const setFetchData = (state, v) => {
  const clonedState = cloneDeep(state);
  clonedState.fetchData = v;
  return clonedState;
};

export default reducer;
